export enum OptionMenuEnum {
    Mandatory = 0,
    NonMandatory = 1,
}